import ToastComponents from './Toast.vue';

const Toast = {
    install:function(Vue) {
        Vue.component('Toast', ToastComponents)
    }
}

export default Toast;


// WEBPACK FOOTER //
// ./src/components/Toast/index.js